import React, { useEffect, useState } from "react";
import { avatarBackgroundColors } from "../../../helper/commonFunctions";
import {
  Button,
  Box,
  TextField,
  Checkbox,
  Avatar,
  debounce,
  Typography,
} from "@mui/material";

const SearchedUser = ({ user, invitedUsers, setInvitedUsers }) => {
  const [selected, setSelected] = useState(false);

  const handleChange = (e) => {
    setSelected(e.target.checked);
    if (e.target.checked) {
      setInvitedUsers((list) => {
        list.push(user);
        return [...list];
      });
    } else {
      if (invitedUsers.length > 0) {
        setInvitedUsers((list) => list.filter((ele) => ele?.id !== user.id));
      } else {
        // "";
      }
    }
  };

  useEffect(() => {
    if (invitedUsers.find((ele) => ele.id == user.id)) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [invitedUsers]);

  return (
    <>
      <Box className="user-div">
        {user.profile_img && false ? (
          <Avatar alt="Cindy Baker" src={user.profile_img} />
        ) : (
          <Avatar
            sx={{
              bgcolor: avatarBackgroundColors[Math.floor(Math.random() * 10)],
              color: "#191b2f",
            }}
          >
            {user.firstName[0].toUpperCase()}
          </Avatar>
        )}

        <Typography component="p" sx={{ flexGrow: "1" }}>
          {user.firstName + " " + user.lastName}
        </Typography>
        <Checkbox
          // defaultChecked
          sx={{
            color: "rgba(25, 27, 47, 0.1)",
            "&.Mui-checked": {
              color: "#D93349",
            },
          }}
          checked={selected}
          onChange={handleChange}
        />
      </Box>
    </>
  );
};

export default SearchedUser;
